"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var mat;
(function (mat) {
    /**
     * Inits a matrix4 from a normalized axis and angle.
     * @param {Vector3} axis A normalized vector representing rotational axis.
     * @param {number} angle Angle of rotation.
     */
    function matrix4FromRotationAxisAngle(axis, angle) {
        // Based on http://www.gamedev.net/reference/articles/article1199.asp
        const c = Math.cos(angle);
        const s = Math.sin(angle);
        const t = 1 - c;
        const x = axis[0];
        const y = axis[1];
        const z = axis[2];
        const tx = t * x;
        const ty = t * y;
        return [
            [tx * x + c, tx * y - s * z, tx * z + s * y, 0],
            [tx * y + s * z, ty * y + c, ty * z - s * x, 0],
            [tx * z - s * y, ty * z + s * x, t * z * z + c, 0],
            [0, 0, 0, 1],
        ];
    }
    mat.matrix4FromRotationAxisAngle = matrix4FromRotationAxisAngle;
    /**
     * Inits a matrix4 from a 3D translation.
     * @param {Vector3} translation A translation vector.
     */
    function matrix4FromTranslation(translation) {
        return [
            [1, 0, 0, translation[0]],
            [0, 1, 0, translation[1]],
            [0, 0, 1, translation[2]],
            [0, 0, 0, 1],
        ];
    }
    mat.matrix4FromTranslation = matrix4FromTranslation;
    function multiply(a, b) {
        const a00 = a[0][0];
        const a01 = a[0][1];
        const a02 = a[0][2];
        const a03 = a[0][3];
        const a10 = a[1][0];
        const a11 = a[1][1];
        const a12 = a[1][2];
        const a13 = a[1][3];
        const a20 = a[2][0];
        const a21 = a[2][1];
        const a22 = a[2][2];
        const a23 = a[2][3];
        const a30 = a[3][0];
        const a31 = a[3][1];
        const a32 = a[3][2];
        const a33 = a[3][3];
        const b00 = b[0][0];
        const b01 = b[0][1];
        const b02 = b[0][2];
        const b03 = b[0][3];
        const b10 = b[1][0];
        const b11 = b[1][1];
        const b12 = b[1][2];
        const b13 = b[1][3];
        const b20 = b[2][0];
        const b21 = b[2][1];
        const b22 = b[2][2];
        const b23 = b[2][3];
        const b30 = b[3][0];
        const b31 = b[3][1];
        const b32 = b[3][2];
        const b33 = b[3][3];
        return [
            [
                a00 * b00 + a01 * b10 + a02 * b20 + a03 * b30,
                a00 * b01 + a01 * b11 + a02 * b21 + a03 * b31,
                a00 * b02 + a01 * b12 + a02 * b22 + a03 * b32,
                a00 * b03 + a01 * b13 + a02 * b23 + a03 * b33,
            ],
            [
                a10 * b00 + a11 * b10 + a12 * b20 + a13 * b30,
                a10 * b01 + a11 * b11 + a12 * b21 + a13 * b31,
                a10 * b02 + a11 * b12 + a12 * b22 + a13 * b32,
                a10 * b03 + a11 * b13 + a12 * b23 + a13 * b33,
            ],
            [
                a20 * b00 + a21 * b10 + a22 * b20 + a23 * b30,
                a20 * b01 + a21 * b11 + a22 * b21 + a23 * b31,
                a20 * b02 + a21 * b12 + a22 * b22 + a23 * b32,
                a20 * b03 + a21 * b13 + a22 * b23 + a23 * b33,
            ],
            [
                a30 * b00 + a31 * b10 + a32 * b20 + a33 * b30,
                a30 * b01 + a31 * b11 + a32 * b21 + a33 * b31,
                a30 * b02 + a31 * b12 + a32 * b22 + a33 * b32,
                a30 * b03 + a31 * b13 + a32 * b23 + a33 * b33,
            ],
        ];
    }
    mat.multiply = multiply;
})(mat = exports.mat || (exports.mat = {}));
//# sourceMappingURL=mat.js.map